import { ShoesState } from 'src/types'
import { getUpperMaterial } from 'src/features/atoms/shoes/logic'

const meshPoint = (ctx: CanvasRenderingContext2D | null, x: number, y: number): void => {
  ctx.beginPath()
  ctx.arc(x, y, 2.5, 0, 2 * Math.PI)
  ctx.fill()
  //   ctx.stroke()
  ctx.closePath()
}

export const generateMesh = (ctx: CanvasRenderingContext2D | null, series: number, x: number, y: number): void => {
  ;[...Array(series)]
    .map((_, i) => i + 0)
    .forEach(
      (i) => meshPoint(ctx, x + i * 6, y - i * 6) // 30, 425
    )
}

const generateMesh2 = (ctx: CanvasRenderingContext2D | null, series, x: number, y: number): void => {
  ;[...Array(series)]
    .map((_, i) => i + 0)
    .forEach(
      (i) => meshPoint(ctx, x + i * 6, y - i * 7) // 30, 425
    )
}

export const meshMaterialWithLaceTypeAndStandingTongue = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  const { isMesh } = getUpperMaterial(state)
  if (!isMesh) return
  ctx.fillStyle = '#ccc' //gradient

  generateMesh(ctx, 7, 30, 425) // つま先1
  generateMesh(ctx, 9, 30, 435) // つま先2
  generateMesh(ctx, 10, 36, 439) // つま先3
  generateMesh(ctx, 11, 42, 443) // つま先4
  generateMesh(ctx, 11, 48, 447) // つま先5
  generateMesh(ctx, 12, 54, 451) // つま先6
  generateMesh(ctx, 12, 60, 455) // つま先7
  generateMesh(ctx, 11, 72, 453) // つま先8
  generateMesh(ctx, 11, 78, 457) // つま先9
  generateMesh(ctx, 10, 84, 461) // つま先10
  generateMesh(ctx, 10, 90, 465) // つま先
  generateMesh(ctx, 9, 96, 469) // つま先
  generateMesh(ctx, 9, 102, 473) // つま先
  generateMesh(ctx, 9, 110, 475) // つま先
  generateMesh(ctx, 8, 118, 478) // つま先
  generateMesh(ctx, 8, 126, 480) // つま先
  generateMesh(ctx, 7, 134, 482) // つま先
  generateMesh(ctx, 6, 142, 484) // つま先
  generateMesh(ctx, 5, 150, 486) // つま先
  generateMesh(ctx, 4, 158, 488) // つま先
  generateMesh(ctx, 3, 166, 490) // つま先
  generateMesh(ctx, 3, 174, 492) // つま先
  generateMesh(ctx, 2, 182, 493) // つま先
  generateMesh(ctx, 1, 192, 495) // つま先

  // つま先横の補強の間
  generateMesh(ctx, 1, 204, 400)
  generateMesh(ctx, 1, 209, 407)
  generateMesh(ctx, 1, 214, 414)
  generateMesh(ctx, 1, 220, 421)
  generateMesh(ctx, 1, 226, 428)
  generateMesh(ctx, 2, 230, 435)
  generateMesh(ctx, 2, 236, 442)
  generateMesh(ctx, 2, 241, 449)
  generateMesh(ctx, 2, 247, 456)
  generateMesh(ctx, 3, 251, 463)
  generateMesh(ctx, 3, 256, 471)
  generateMesh(ctx, 3, 261, 478)
  generateMesh(ctx, 3, 265, 485)
  generateMesh(ctx, 4, 269, 492)
  generateMesh(ctx, 4, 274, 499)
  generateMesh(ctx, 4, 279, 506)
  generateMesh(ctx, 3, 289, 508)
  generateMesh(ctx, 2, 300, 508)

  //   ATOMSマーク左上_左
  generateMesh(ctx, 2, 234, 364)
  generateMesh(ctx, 3, 241, 368)
  generateMesh(ctx, 4, 248, 372)
  generateMesh(ctx, 5, 255, 376)
  generateMesh(ctx, 7, 262, 380)

  //   ATOMSマーク左上_左
  generateMesh(ctx, 2, 269, 384)
  generateMesh(ctx, 2, 276, 388)
  generateMesh(ctx, 3, 283, 392)
  generateMesh(ctx, 4, 290, 396)
  generateMesh(ctx, 3, 297, 400)
  generateMesh(ctx, 2, 304, 404)

  //  ATOMSマーク右上
  generateMesh(ctx, 1, 390, 323)
  generateMesh(ctx, 2, 399, 324)
  generateMesh(ctx, 3, 408, 325)
  generateMesh(ctx, 4, 415, 328)
  generateMesh(ctx, 6, 423, 331)
  generateMesh(ctx, 7, 432, 333)
  generateMesh(ctx, 9, 441, 335)
  generateMesh(ctx, 10, 450, 337)
  generateMesh(ctx, 4, 459, 339)

  //  ATOMSマーク右下
  meshPoint(ctx, 427, 453)
  meshPoint(ctx, 432, 446)
  meshPoint(ctx, 438, 439)
  meshPoint(ctx, 444, 432)
  meshPoint(ctx, 450, 425)
  meshPoint(ctx, 456, 418)

  //   meshPoint(ctx, 466, 418)
  // generateMesh(ctx, , )

  // +6, -7
  generateMesh2(ctx, 17, 496, 345)
  generateMesh2(ctx, 21, 507, 345)
  generateMesh2(ctx, 21, 515, 348)
  generateMesh2(ctx, 15, 490, 338)
  generateMesh2(ctx, 7, 523, 286)

  generateMesh2(ctx, 41, 401, 495)
  //   generateMesh2(ctx, 40, 412, 492)
  generateMesh2(ctx, 39, 418, 489)
  generateMesh2(ctx, 38, 433, 486)
  generateMesh2(ctx, 37, 447, 483)
  generateMesh2(ctx, 36, 460, 480)
  generateMesh2(ctx, 36, 467, 484)
  generateMesh2(ctx, 35, 477, 484)
  generateMesh2(ctx, 34, 487, 484)
  generateMesh2(ctx, 34, 497, 484)
  generateMesh2(ctx, 33, 507, 484)
  generateMesh2(ctx, 33, 517, 484)
  generateMesh2(ctx, 32, 527, 484)
  generateMesh2(ctx, 32, 537, 484)
  generateMesh2(ctx, 31, 547, 484)
  generateMesh2(ctx, 26, 580, 458)
  generateMesh2(ctx, 20, 619, 426)
  generateMesh2(ctx, 19, 634, 420)
  generateMesh2(ctx, 16, 658, 405)
  generateMesh2(ctx, 13, 684, 388)
  generateMesh2(ctx, 11, 704, 378)
  generateMesh2(ctx, 8, 734, 358)
  generateMesh2(ctx, 6, 752, 350)
  generateMesh2(ctx, 5, 772, 340)
  generateMesh2(ctx, 5, 783, 340)
  generateMesh2(ctx, 4, 795, 338)
  generateMesh2(ctx, 4, 810, 333)
  generateMesh2(ctx, 2, 830, 323)

  //   generateMesh2(ctx, 7, 484, 474)
  //   generateMesh2(ctx, 7, 484, 474)
}

export const meshMaterialWithFoldingTongue = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  const { isMesh } = getUpperMaterial(state)
  if (!isMesh) return
  ctx.fillStyle = '#ccc' //gradient

  generateMesh(ctx, 7, 30, 425) // つま先1
  generateMesh(ctx, 9, 30, 435) // つま先2
  generateMesh(ctx, 10, 36, 439) // つま先3
  generateMesh(ctx, 11, 42, 443) // つま先4
  generateMesh(ctx, 11, 48, 447) // つま先5
  generateMesh(ctx, 12, 54, 451) // つま先6
  generateMesh(ctx, 12, 60, 455) // つま先7
  generateMesh(ctx, 11, 72, 453) // つま先8
  generateMesh(ctx, 11, 78, 457) // つま先9
  generateMesh(ctx, 10, 84, 461) // つま先10
  generateMesh(ctx, 10, 90, 465) // つま先
  generateMesh(ctx, 9, 96, 469) // つま先
  generateMesh(ctx, 9, 102, 473) // つま先
  generateMesh(ctx, 9, 110, 475) // つま先
  generateMesh(ctx, 8, 118, 478) // つま先
  generateMesh(ctx, 8, 126, 480) // つま先
  generateMesh(ctx, 7, 134, 482) // つま先
  generateMesh(ctx, 6, 142, 484) // つま先
  generateMesh(ctx, 5, 150, 486) // つま先
  generateMesh(ctx, 4, 158, 488) // つま先
  generateMesh(ctx, 3, 166, 490) // つま先
  generateMesh(ctx, 3, 174, 492) // つま先
  generateMesh(ctx, 2, 182, 493) // つま先
  generateMesh(ctx, 1, 192, 495) // つま先

  // つま先横の補強の間
  generateMesh(ctx, 1, 204, 400)
  generateMesh(ctx, 1, 209, 407)
  generateMesh(ctx, 1, 214, 414)
  generateMesh(ctx, 1, 220, 421)
  generateMesh(ctx, 1, 226, 428)
  generateMesh(ctx, 2, 230, 435)
  generateMesh(ctx, 2, 236, 442)
  generateMesh(ctx, 2, 241, 449)
  generateMesh(ctx, 2, 247, 456)
  generateMesh(ctx, 3, 251, 463)
  generateMesh(ctx, 3, 256, 471)
  generateMesh(ctx, 3, 261, 478)
  generateMesh(ctx, 3, 265, 485)
  generateMesh(ctx, 4, 269, 492)
  generateMesh(ctx, 4, 274, 499)
  generateMesh(ctx, 4, 279, 506)
  generateMesh(ctx, 3, 289, 508)
  generateMesh(ctx, 2, 300, 508)

  //   ATOMSマーク左上_左
  generateMesh(ctx, 2, 234, 364)
  generateMesh(ctx, 3, 241, 368)
  generateMesh(ctx, 4, 248, 372)
  generateMesh(ctx, 5, 255, 376)
  generateMesh(ctx, 7, 262, 380)

  //   ATOMSマーク左上_左
  generateMesh(ctx, 2, 269, 384)
  generateMesh(ctx, 2, 276, 388)
  generateMesh(ctx, 3, 283, 392)
  generateMesh(ctx, 4, 290, 396)
  generateMesh(ctx, 3, 297, 400)
  generateMesh(ctx, 2, 304, 404)

  //  ATOMSマーク右上
  generateMesh(ctx, 1, 390, 323)
  generateMesh(ctx, 2, 399, 324)
  generateMesh(ctx, 3, 408, 325)
  generateMesh(ctx, 4, 415, 328)
  generateMesh(ctx, 6, 423, 331)
  generateMesh(ctx, 7, 432, 333)
  generateMesh(ctx, 9, 441, 335)
  generateMesh(ctx, 10, 450, 337)
  generateMesh(ctx, 4, 459, 339)

  //  ATOMSマーク右下
  meshPoint(ctx, 427, 453)
  meshPoint(ctx, 432, 446)
  meshPoint(ctx, 438, 439)
  meshPoint(ctx, 444, 432)
  meshPoint(ctx, 450, 425)
  meshPoint(ctx, 456, 418)

  //   meshPoint(ctx, 466, 418)
  // generateMesh(ctx, , )

  generateMesh2(ctx, 17, 496, 345)
  generateMesh2(ctx, 16, 507, 345)
  generateMesh2(ctx, 16, 515, 348)
  generateMesh2(ctx, 15, 490, 338)
  generateMesh2(ctx, 7, 523, 286)

  generateMesh2(ctx, 31, 401, 495)
  //   generateMesh2(ctx, 40, 412, 492)
  generateMesh2(ctx, 29, 418, 489)
  generateMesh2(ctx, 28, 433, 486)
  generateMesh2(ctx, 27, 447, 483)
  generateMesh2(ctx, 27, 460, 480)
  generateMesh2(ctx, 27, 467, 484)
  generateMesh2(ctx, 26, 477, 484)
  generateMesh2(ctx, 26, 487, 484)
  generateMesh2(ctx, 26, 497, 484)
  generateMesh2(ctx, 25, 507, 484)
  generateMesh2(ctx, 28, 517, 484)
  generateMesh2(ctx, 28, 527, 484)
  generateMesh2(ctx, 28, 537, 484)
  generateMesh2(ctx, 25, 547, 484)
  generateMesh2(ctx, 26, 580, 458)
  generateMesh2(ctx, 20, 619, 426)
  generateMesh2(ctx, 19, 634, 420)
  generateMesh2(ctx, 16, 658, 405)
  generateMesh2(ctx, 13, 684, 388)
  generateMesh2(ctx, 11, 704, 378)
  generateMesh2(ctx, 8, 734, 358)
  generateMesh2(ctx, 6, 752, 350)
  generateMesh2(ctx, 5, 772, 340)
  generateMesh2(ctx, 5, 783, 340)
  generateMesh2(ctx, 4, 795, 338)
  generateMesh2(ctx, 4, 810, 333)
  generateMesh2(ctx, 2, 830, 323)

  //   generateMesh2(ctx, 7, 484, 474)
  //   generateMesh2(ctx, 7, 484, 474)
}

export const meshMaterialStandingTongue = (ctx: CanvasRenderingContext2D | null, state: ShoesState, x: number, y: number): void => {
  const { isMesh } = getUpperMaterial(state)
  if (!isMesh) return
  ctx.fillStyle = '#ccc' //gradient

  generateMesh(ctx, 5, 545 + x, 190 + y) //
  generateMesh(ctx, 8, 556 + x, 190 + y) //
  generateMesh(ctx, 8, 566 + x, 190 + y) //
  generateMesh(ctx, 9, 570 + x, 197 + y) //
  generateMesh(ctx, 9, 577 + x, 202 + y) //
  generateMesh(ctx, 9, 586 + x, 205 + y) //
  generateMesh(ctx, 9, 593 + x, 211 + y) //
  generateMesh(ctx, 10, 596 + x, 220 + y) //
  generateMesh(ctx, 10, 603 + x, 225 + y) //
  generateMesh(ctx, 10, 610 + x, 230 + y) //
  generateMesh(ctx, 10, 617 + x, 235 + y) //
  generateMesh(ctx, 9, 624 + x, 240 + y) //
  generateMesh(ctx, 9, 630 + x, 245 + y) //
  generateMesh(ctx, 9, 637 + x, 249 + y) //
  generateMesh(ctx, 8, 642 + x, 255 + y) //
  generateMesh(ctx, 8, 649 + x, 260 + y) //
}
